import React from 'react';
import { Box, FormControl, InputLabel, MenuItem, Select, TextField } from '@mui/material';
import type { PlayerProfileFormProps } from './types';
import { asNumber, asString, setNumber, setString } from './helpers';

export const HandballPlayerProfileForm: React.FC<PlayerProfileFormProps> = ({ value, onChange }) => (
  <Box sx={{ display: 'grid', gap: 1.5, gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' } }}>
    <FormControl fullWidth size="small">
      <InputLabel>Позиция</InputLabel>
      <Select
        value={asString(value.position)}
        label="Позиция"
        onChange={(e) => setString(value, 'position', e.target.value, onChange)}
      >
        <MenuItem value="goalkeeper">Вратарь</MenuItem>
        <MenuItem value="left_wing">Левый край</MenuItem>
        <MenuItem value="right_wing">Правый край</MenuItem>
        <MenuItem value="back">Полусредний</MenuItem>
        <MenuItem value="center_back">Разыгрывающий</MenuItem>
        <MenuItem value="pivot">Линейный</MenuItem>
      </Select>
    </FormControl>
    <FormControl fullWidth size="small">
      <InputLabel>Бросковая рука</InputLabel>
      <Select
        value={asString(value.throwingHand)}
        label="Бросковая рука"
        onChange={(e) => setString(value, 'throwingHand', e.target.value, onChange)}
      >
        <MenuItem value="left">Левая</MenuItem>
        <MenuItem value="right">Правая</MenuItem>
      </Select>
    </FormControl>
    <TextField label="Номер" size="small" value={asNumber(value.number)} onChange={(e) => setNumber(value, 'number', e.target.value, onChange)} />
    <TextField label="Рост (см)" size="small" value={asNumber(value.heightCm)} onChange={(e) => setNumber(value, 'heightCm', e.target.value, onChange)} />
    <TextField label="Вес (кг)" size="small" value={asNumber(value.weightKg)} onChange={(e) => setNumber(value, 'weightKg', e.target.value, onChange)} />
  </Box>
);
